import React from 'react';
import { useTranslation } from 'react-i18next';

interface UserStatusProps {
  status: 'active' | 'inactive' | 'deleted';
  text?: string;
}

const UserStatusBadge: React.FC<UserStatusProps> = ({ status, text }) => {
  const { t } = useTranslation();
  const getBadgeStatus = () => {
    switch (status) {
      case 'active':
        return 'success';
      case 'inactive':
        return 'warning';
      case 'deleted':
        return 'danger';
      default:
        return 'danger';
    }
  };

  const getDefaultText = () => {
    switch (status) {
      case 'active':
        return t('active');
      case 'inactive':
        return t('inactive');
      case 'deleted':
        return t('deleted');
      default:
        return t('unknown');
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeStatus()} d-inline-flex align-items-center`}>
      <i className="ti ti-circle-filled fs-5 me-1"></i>
      {text || getDefaultText()}
    </span>
  );
};

export default UserStatusBadge;